import { cn } from '@/lib/utils';
import { Input as Root } from 'ui/input';

import { PostalCodeIcon } from '@/icons/postal-code-icon';
import { useFormField } from '.';
import { FormField } from './Field';
import { UseFormFieldProps } from './type';

interface Props extends UseFormFieldProps, React.ComponentProps<typeof Root> {
  name: string;
}

const Input = (props: Props) => {
  const { formFieldProps, childProps, error } = useFormField(props);
  const isDate = childProps.type === 'date';
  const isPostalCode = formFieldProps.name === 'postalCode';
  return (
    <FormField {...formFieldProps}>
      <div className="relative">
        {isPostalCode && (
          <PostalCodeIcon className="absolute left-[13px] top-1/2 text-muted-foreground -translate-y-1/2 size-[20px]" />
        )}

        <Root
          {...childProps}
          data-test={childProps.id}
          className={cn(
            error ? 'border-destructive focus-visible:ring-destructive' : '',
            isDate && 'block',
            props.className,
            isPostalCode && 'pl-[43px]',
          )}
        />
      </div>
    </FormField>
  );
};

export default Input;
